import * as React from 'react'

import moment from 'moment'

import { dateToString, stringToDate } from 'modules/core/lib/dates'

import Employee from 'modules/employees/store/models/Employee'

const frequencyContext = React.createContext<StateType | null>(null)

const PeriodProvider = frequencyContext.Provider

interface StateType {
  date: moment.Moment
  setDate: (value: moment.Moment) => void
  frequency: string
  setFrequency: (value: string) => void
}

export const FrequencyContextProvider = ({
  children,
}: React.PropsWithChildren<Record<string, unknown>>) => {
  const firstOfMonth: string = dateToString(moment().startOf('month'), 'backend')

  const [date, setDate] = React.useState<moment.Moment>(stringToDate(firstOfMonth, 'backend'))

  const [frequency, setFrequency] = React.useState<string>(
    Employee.PAYMENT_FREQUENCIES.monthly ?? ''
  )

  const values = {
    date,
    setDate,
    frequency,
    setFrequency,
  }

  return <PeriodProvider value={values}>{children}</PeriodProvider>
}

export const useFrequency = () => {
  const results = React.useContext(frequencyContext)

  if (!results) {
    throw new Error('useFrequency hook must be used within a PeriodProvider provider')
  }

  return results
}
